import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bd3e23fe: FaireBrandEntity = {
  token: "b_bd3e23fe",
  type: "brand",
  name: "ZAD",
  avatarUrl:
    "https://cdn.faire.com/fastly/90952c1478ae719dff9726b435b83b0a77bac11b41dcc5c2c33a70f247e45f7c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c6ce9d63360d3418aa14b41d16d2635cba9b1bc2e7edcf665384c2927dac0ca5.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/90952c1478ae719dff9726b435b83b0a77bac11b41dcc5c2c33a70f247e45f7c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c6ce9d63360d3418aa14b41d16d2635cba9b1bc2e7edcf665384c2927dac0ca5.jpeg",
  location: "Portland, OR, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 1637,
  isTopShop: true,
  isInsider: true,
  description:
    "ZAD started in 1986 and is a story based in playful creativity, fun and affordable fashion for any budget. \nThese core values drive the creation of our collections and have earned ZAD placement in fashionable boutiques across the country for more than 3 decades!\nWe look forward to working with you!\n\nProducts made in India, China, Peru, Thailand\n\nAll 'ZAD Jewelry is Lead, Nickel & Cadmium Free in compliance with all U.S. & State requirements & the CPSIA\n\n`ZAD Jewelry is not intended for use by children under 12",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:08.670Z",
    importedBy: "entity-db-cli",
  },
};
